// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"a983bd25","453":"54292a4b","576":"baa00e65"}[chunkId] + ".chunk.js";
};